const values = {
  BATCH_NAME: "Batch Name",
  PARAMETER_NAME: "Parameter Name",
  VALUE: "Value",
  PDF_NAME: "Pdf Name",
  OUT_OF_RANGE: "Out of Range",
  PAGE_NO: "Page No.",
  UPDATED_ON: "Updated On(GMT)",
  FILE_NAME: "File Name",
  FILE_TYPE: "File Type",
  PREVIEW: "Preview",
  PRODUCT_NAME: "Product Name",
  TEMPLATE_NAME: "Template Name",
};

export default Object.freeze(values);
